import Home from "../pages/landing/Home";
import HomePageOrder from "../pages/HomePageOrder";
import Login from "../pages/Login";
import Register from "../pages/Register";
import OrderChooseSize from "../pages/OrderChooseSize";
import OrderChooseToppings from "../pages/OrderChooseToppings";
import EmailRecuperationPassword from "../pages/recuperation_password/EmailRecuperationPassword";
import HomeAdmin from "../pages/admin/HomeAdmin";
import AdminProducts from "../pages/admin/AdminProducts";
import CartPage from "../pages/CartPage";
import Orders from "../pages/Orders";
import CashierPanel from "../pages/cashier/CashierPanel";
import AdminReportsPage from "../pages/admin/AdminReportsPage";
import Profile from "../pages/Profile";
import CashierPendingOrders from "../pages/cashier/CashierPendingOrders";
import AdminClients from "../pages/admin/AdminClients";
import TermsAndConditions from "../pages/TermsAndConditions";
import AdminSchedule from "../pages/admin/AdminSchedule";
import BranchSelectionUser from "../pages/BranchSelectionUser";
import BranchSelectionAdmin from "../pages/admin/BranchSelection";
const routes = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/terms-and-conditions",
    element: <TermsAndConditions />,
  },

  {
    path: "/recover-password",
    element: <EmailRecuperationPassword />,
  },

  {
    path: "/home/food_order",
    element: <BranchSelectionUser />,
  },
  {
    path: "/home/food_order/:branch_id",
    element: <HomePageOrder />,
  },
  {
    path: "/home/food_order/:branch_id/burguer_type/:type_id",
    element: <OrderChooseSize />,
  },

  {
    path: "/home/food_order/:branch_id/burguer_type/:type_id/size/:size_id",
    element: <OrderChooseToppings />,
  },
  {
    path: "/cart/:branch_id",
    element: <CartPage />,
  },
  {
    path: "/orders",
    element: <Orders />,
  },
  {
    path: "/perfil",
    element: <Profile />,
  },

  //ADMIN
  {
    path: "/home/admin_panel",
    element: <BranchSelectionAdmin />,
  },

  {
    path: "/home/admin_panel/:id_branch",
    element: <HomeAdmin />,
  },

  {
    path: "/home/admin_panel/:id_branch/products",
    element: <AdminProducts />,
  },

  {
    path: "/home/admin_panel/:id_branch/reports",
    element: <AdminReportsPage />,
  },

  {
    path: "/home/admin_panel/:id_branch/clients",
    element: <AdminClients />,
  },

  {
    path: "/home/admin_panel/:id_branch/schedule",
    element: <AdminSchedule />,
  },

  //CASHIER
  {
    path: "/home/cashier",
    element: <CashierPanel />,
  },
  {
    path: "/cashier/pending_orders",
    element: <CashierPendingOrders />,
  },
];

export default routes;
